module.exports = __webpack_public_path__ + "static/media/phone.3977faf2.svg";